import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FolderIcon from '@material-ui/icons/Folder';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import Tooltip from '@material-ui/core/Tooltip';
import { CardsSpade as DeckspecIcon, FileOutline as FileIcon, FolderOpen as FolderOpenIcon } from 'mdi-material-ui';
import React, { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    treeView: {
      color: theme.palette.text.secondary
    },
    treeItemLabel: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  })
);

function renderTreeNode(node, classes, onClick) {
  return (
    <TreeItem
      key={node.id}
      label={<Tooltip title={node.name}><Typography component="span">{node.name}</Typography></Tooltip>}
      nodeId={node.id}
      icon={node.id.endsWith('.deckspec') ? <DeckspecIcon /> : null}
      onClick={() => onClick(node)}
      classes={{ label: classes.treeItemLabel }}
    >
      {node.children.length > 0 && node.children.map(child => renderTreeNode(child, classes, onClick))}
    </TreeItem>
  );
}

interface Props {
  rootNode: object;
  defaultSelectedNodeId: string;
  onClick: (filename: string) => void;
}

function getParentNodeIds(nodeId) {
  const nodes = [];
  let startIndex = 0;
  while (startIndex < nodeId.length) {
    const index = nodeId.indexOf('/', startIndex);
    if (index !== -1) {
      nodes.push(nodeId.substring(0, index));
      startIndex = index + 1;
    } else {
      startIndex = nodeId.length;
    }
  }
  return nodes;
}

function FaroDeckFileTreePanel(props: Props & RouteComponentProps<any>) {
  const { rootNode, defaultSelectedNodeId, onClick } = props;
  const [defaultExpanded] = useState(getParentNodeIds(defaultSelectedNodeId));
  const classes = useStyles({});

  return (
    <div>
      <TreeView
        defaultExpanded={defaultExpanded}
        defaultSelected={defaultSelectedNodeId}
        className={classes.treeView}
        defaultCollapseIcon={<FolderOpenIcon />}
        defaultExpandIcon={<FolderIcon />}
        defaultEndIcon={<FileIcon />}
      >
        {rootNode.children.map(child => renderTreeNode(child, classes, onClick))}
      </TreeView>
    </div>
  );
};

export default withRouter(FaroDeckFileTreePanel);
